import React from 'react'
import Link from 'gatsby-link'
import './about-us.css'

const AboutUs = ({ siteTitle }) => (
  <div className="section-about" id="about-us">
    <div className="left">
      <h1>About Us</h1>
      <p>Our team has over 100 years of combined experience in product and business development, working with 
        Fortune 500 and other high technology companies including Alcatel-Lucent, Motorola, MCI, AT&T, Comcast, VCE, 
        Federal Express, and SOPRIS Technologies. We optimize business capabilities and add long term value to corporations 
        through technology driven solutions; increasing efficiency, reducing costs and growing revenue.</p>
      <p>
        The WanClouds Miami family excels in human relations and capital development. By building our team with the right candidates, 
        creating leaders and fostering growth within the company we ensure only the highest standards are met. Determination, curiosity, 
        motivation, excellence, and attention to detail are a must within our team members. Passion is in our every movement.
      </p>
    </div>
  </div> 
)

export default AboutUs



// WEBPACK FOOTER //
// ./src/components/about-us/about-us.js